import React, { FC } from "react";

export const Row: FC = ({ children }) => <div className="row">{children}</div>;
